module.exports = __webpack_public_path__ + "img/Frame-69.9c47098f.svg";